import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditUserLoginLogout from "./components/ListAllAuditUserLoginLogout";

export default function AuditUserLoginLogoutable() {
    const { translate } = useLang();
    
    

    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Login/Logout')}`} />
            <ListAllAuditUserLoginLogout />
        </>
    )
}